import { SERVICE_TO_TAG_MAP, TWO_FACTOR_AUTH_TAGS } from './constants';

const parseTagValue = value => {
    switch (value) {
        case 'true': return true;
        case 'false': return false;
        default: return value;
    }
};

const toTagValue = (key, value) => {
    if (key === 'channel') {
        return value;
    }

    return value ? 'true' : 'false';
};

const tagValueGetter = tags => key => parseTagValue(tags.find(({ name }) => name === `uam/2fa/${key}`)?.value);

const serviceOptionGetter = services => key => services.find(({ service }) => service === key)?.option;

export const parse = ([twoFactorConf, tags]) => {
    const { enabled, defaultChannel, configuredServices } = twoFactorConf;

    const getTagValue = tagValueGetter(tags);
    const getServiceOption = serviceOptionGetter(configuredServices || []);
    const isAvailable = (name) => getServiceOption(SERVICE_TO_TAG_MAP[name].service) === 'PLAYER';
    const isChecked = (name) => getTagValue(SERVICE_TO_TAG_MAP[name].tag) || false;
    const tagChannel = getTagValue('2FAChannel');
    const channel = ['sms', 'email'].includes(tagChannel?.toLowerCase()) ? tagChannel : '';
    const notifications = getTagValue('2FANotificationMessages');
    const availableItems = Object.keys(SERVICE_TO_TAG_MAP)
        .filter(key => isAvailable(key));
    const formData = availableItems.reduce((acc, key) => ({
        ...acc,
        [key]: isChecked(key)
    }), {});

    formData.notifications = notifications || false;
    formData.channel = (channel || defaultChannel || '').toLowerCase();

    const initialValues = { ...formData };

    return { enabled, formData, initialValues };
};

export const prepareTags = (formData, initialValues = {}) => {
    return Object.keys(formData)
        .filter(key => TWO_FACTOR_AUTH_TAGS[key] && formData[key] !== initialValues[key])
        .map(key => ({
            name: TWO_FACTOR_AUTH_TAGS[key],
            value: toTagValue(key, formData[key]),
            type: 'text'
        }));
};
